module.exports = __webpack_public_path__ + "static/media/meCard-other.5c2773d2.jpg";